var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .75A.75.75 0 0 1 .75 0H10a.75.75 0 0 1 0 1.5H1.5v15h15V8A.75.75 0 0 1 18 8v9.25a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75V.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M13.7197.2197a.75.75 0 0 1 1.0606 0l2.8285 2.8284a.75.75 0 0 1 0 1.0606l-9.1924 9.1924a.7498.7498 0 0 1-.5304.2197H5.0576a.75.75 0 0 1-.75-.75V9.9424a.75.75 0 0 1 .2197-.5303L13.7197.2197Zm.5303 1.591-1.0607 1.0606 1.7678 1.7678 1.0607-1.0607L14.25 1.8107Zm-.3536 3.889L12.1287 3.932l-6.321 6.321v1.7678h1.7677l6.321-6.321Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencil-edit.e2b63306e4827b668ba77b0142a16c64.svg";
export { ForwardRef as ReactComponent };